interface SectionHeaderProps {
  title: string;
  chineseTitle?: string;
  accentColor?: 'emerald' | 'red' | 'blue' | 'amber';
}

const accentColors = {
  emerald: 'bg-emerald-600',
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  amber: 'bg-amber-500',
};

export function SectionHeader({ title, chineseTitle, accentColor = 'emerald' }: SectionHeaderProps) {
  return (
    <div className="mb-8 pt-8">
      <div className="flex items-center gap-3">
        <div className={`w-1 h-8 ${accentColors[accentColor]} rounded-full`} />
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
          {title}
        </h2>
        {chineseTitle && (
          <span className="text-lg text-gray-500 font-normal">{chineseTitle}</span>
        )}
      </div>
    </div>
  );
}

interface SubsectionHeaderProps {
  title: string;
  chineseTitle?: string;
}

export function SubsectionHeader({ title, chineseTitle }: SubsectionHeaderProps) {
  return (
    <h3 className="text-lg font-medium text-gray-700 mb-4 pb-2 border-b border-gray-200">
      {title}
      {chineseTitle && (
        <span className="text-gray-500 font-normal ml-2">{chineseTitle}</span>
      )}
    </h3>
  );
}
